import { Pipe, PipeTransform } from '@angular/core';
import { InterventionStepType } from '../models/intervention';

const interventionStepTypePipeText: { [key in InterventionStepType]: string } = {
  [InterventionStepType.CARE_MANAGER_INTERVENTIONS]: 'Care Manager Interventions',
  [InterventionStepType.HEART_FAILURE_INTERVENTION]: 'Heart Failure Intervention',
  [InterventionStepType.CHRONIC_KIDNEY_DISEASE_INTERVENTION]: 'Chronic Kidney Disease Intervention',
  [InterventionStepType.PREVENTIVE_CARE_GAPS]: 'Preventative Care Gaps'
};

@Pipe({ name: 'interventionStepType' })
export class InterventionStepTypePipe implements PipeTransform {
  transform(value: InterventionStepType | string): string {
    return interventionStepTypePipeText[value] || '';
  }
}
